import React from "react"

import { getViewId } from "~/Views/helpers"

import { useViews } from "~/Views/useViews"
import { useAppSelector } from "~/hooks/redux"
import useDeferredValueStringified from "~/hooks/useDeferredValueStringified"

import FilteredPlannerContext from "./FilteredPlannerContext"

type Props = {
  children: React.ReactNode
  projectIDs: number[]
  peopleIDs: number[]
  totalProjectCount: number
  totalPeopleCount: number
}

const FilteredPlannerProvider = (props: Props) => {
  const { selectedView } = useViews()
  const additionalPlannerIds = useAppSelector(
    (state) => state.plannerV2.temporaryFilter.additionalPlannerIds,
  )[getViewId(selectedView)] ?? { projectIds: [], peopleIds: [] }
  const deferredAdditionalPlannerIds =
    useDeferredValueStringified(additionalPlannerIds)

  const temporaryPlannerFilter = useAppSelector(
    (state) => state.plannerV2.temporaryFilter.temporaryPlannerFilter,
  )
  const allProjectIDs = [
    ...deferredAdditionalPlannerIds.projectIds,
    ...props.projectIDs,
  ]
  const allPeopleIDs = [
    ...deferredAdditionalPlannerIds.peopleIds,
    ...props.peopleIDs,
  ]
  const temporaryProjectsFilters = useDeferredValueStringified(
    temporaryPlannerFilter.projectFilters,
  )
  const temporaryPeopleFilters = useDeferredValueStringified(
    temporaryPlannerFilter.peopleFilters,
  )

  return (
    <FilteredPlannerContext.Provider
      value={{
        projectIDs: allProjectIDs,
        peopleIDs: allPeopleIDs,
        totalProjectCount: props.totalProjectCount,
        totalPeopleCount: props.totalPeopleCount,
        temporaryProjectFilters: temporaryProjectsFilters,
        temporaryPeopleFilters: temporaryPeopleFilters,
      }}
    >
      {props.children}
    </FilteredPlannerContext.Provider>
  )
}

export default FilteredPlannerProvider
